export const customerRecordingGuide = {
  title: 'How to ask a customer to record a bug without another support call',
  slug: 'ask-customer-to-record-a-bug-without-a-support-call',
  date: '2026-10-01',
  description: 'Ask a customer to record one bug flow, keep private data out, and turn the clip into a useful next check. Includes a request template and worked example.',
} as const;
